import classNames from "classnames";
import { IMenuItem } from "dots-ui/dotsMenuBar";
import { NavigateFunction } from "react-router-dom";
//import { RightsHolderSelect } from "../components/rightsHolder/RightsHolderSelect";
import { SessionInfo } from "../components/session/SessionInfo";
import { isMobileView } from "../components/shared/appStates/appStates";
import { AvisLogoInteractive } from "../components/shared/components/logo/AvisLogoInteractive";
import { IPortalKind, ResCallback } from "../models";
import { AvisConstants } from "./avisConstants";
import { AuthorsUtils } from "../utils";
import { RightsHolderInfoViewModel } from "../generated/data-contracts";

type MenuItemTypeKeys =
  | "separator"
  | "spacer"
  | "logo"
  | "rights-holders"
  | "user-settings"
  | "user"
  | "sessionInfo"
  | "logout";

type MenuDictionary = { [key in MenuItemTypeKeys]: IMenuItem };

export function avisLogoMenuItem(): IMenuItem {
  const colClassName = !isMobileView.value ? "col-1" : "";
  return {
    key: "logo",
    className: colClassName,
    wrapCustomLayout: false,
    customLayout: () => <AvisLogoInteractive />,
  };
}

export function horizontalBarMenuItems(
  onLogout: () => void,
  navigate: NavigateFunction,
  res: ResCallback,
  portalKind: IPortalKind,
  ctxRightsHolder?: RightsHolderInfoViewModel,
  ctxRightsHolders?: RightsHolderInfoViewModel[],
  onRightsHolderActionClick?: () => void,
): MenuDictionary {
  const colClassName = !isMobileView.value && "col-1";
  const userClassName = classNames(colClassName, "nav-user-section");
  const singleRightsHolder = (ctxRightsHolders ?? [])?.length === 1;
  const rhMenuClassName = classNames(
    "rights-holders-change-menu",
    singleRightsHolder ? "single-rights-holder" : "",
  );

  const rightsHoldersMenuItem = () => {
    return {
      key: "rights-holders",
      className: rhMenuClassName,
      label: ctxRightsHolder
        ? res(
            "authors_RightsHolders_SelectRightsHolder_label",
            AuthorsUtils.getRightsHolderFullName(ctxRightsHolder),
          )
        : "",
      items: !singleRightsHolder
        ? [
            {
              key: "change-rights-holder",
              label: res("authors_RightsHolders_Change"),
              command: () => {
                onRightsHolderActionClick?.();
              },
              className: "avis-vertical-bar-submenu-item",
            },
          ]
        : undefined,
    };
  };

  return {
    logo: avisLogoMenuItem(),
    "rights-holders": rightsHoldersMenuItem(),
    user: {
      key: "user",
      label: res("horizontalMenuBar_UserTitle"),
      title: true,
    },
    "user-settings": {
      key: "user-settings",
      className: userClassName,
      icon: "fas fa-user",
      label: res("horizontalMenuBar_UserSettingsTitle"),
      items: [
        {
          key: "change-password",
          label: res("horizontalMenuBar_ChangePasswordTitle"),
          url: AvisConstants.url_change_password,
          command: () =>
            navigate(
              `/${portalKind.portalType}${AvisConstants.url_change_password}`,
            ),
          className: "avis-vertical-bar-submenu-item",
        },
      ],
      tooltip: res("horizontalMenuBar_UserSettingsTitle"),
    },
    spacer: {
      key: "avis-spacer",
      classNames: "spacer",
      wrapCustomLayout: false,
      customLayout: () => <div className="avis-spacer"></div>,
    },
    separator: {
      key: "sep",
      separator: true,
    },
    logout: {
      key: "logout",
      className: colClassName,
      icon: "fas fa-power-off",
      label: res("button_Exit"),
      command: onLogout,
      tooltip: res("button_Exit"),
    },
    sessionInfo: {
      key: "session-info",
      className: colClassName,
      wrapCustomLayout: false,
      customLayout: () => <SessionInfo />,
    },
  } as MenuDictionary;
}
